export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="portal-footer">
      © {year} Xino Solutions · Admin
    </footer>
  );
}
